export default {
    404: {
        "oops": "Oops!",
        "error_message": "The page you are looking for is currently unavailable. Error code: 404",
        "go_back": "Go back to Home",
    }
};
